import { Link } from "react-router-dom";
import { SiFacebook, SiX, SiInstagram } from "react-icons/si";

import Logo from "../images/logo.png";
import WorldDataSystem from "../images/image-20250422-174508.png";

/**
 * Returns the Footer component.
 *
 * @returns The Footer component.
 */
const Footer = () => {
  return (
    <>
      <footer className="bg-gray-100 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:py-8 sm:px-10">
          <div className="grid lg:grid-cols-3 grid-cols-1 lg:gap-16 gap-y-16">
            <div className="">
              <img
                src={Logo}
                alt="Arctic Research Foundation Logo"
                className="mb-4 sm:w-40 w-32 dark:invert"
              />

              <p className="text-gray-600 text-base leading-6 mb-4 dark:text-gray-400">
                Arctic Research Foundation (ARF) is a private, non-profit
                organization creating a new kind of scientific infrastructure
                for the Canadian Arctic, through our operation of efficient,
                cutting-edge research vessels and self-powered mobile labs.
              </p>

              <div className="flex space-x-6 items-center">
                <a
                  target="_blank"
                  href=" https://www.facebook.com/arcticfocus/"
                  className="text-gray-500 hover:text-gray-500 "
                >
                  <span className="sr-only">Facebook</span>

                  <SiFacebook className="h-6 w-6" />
                </a>

                <a
                  target="_blank"
                  className="text-gray-500 hover:text-gray-500"
                  href="https://www.instagram.com/arcticfocus/?hl=en"
                >
                  <span className="sr-only">Instagram</span>

                  <SiInstagram className="h-6 w-6" />
                </a>

                <a
                  target="_blank"
                  className="text-gray-500 hover:text-gray-500"
                  href="https://twitter.com/arcticfocus?lang=en"
                >
                  <span className="sr-only">Twitter</span>

                  <SiX className="h-6 w-6" />
                </a>
              </div>

              <div>
                <a href="https://worlddatasystem.org/" target="_blank">
                  <img src={WorldDataSystem} alt="World Data System" className="partner-logo"/>
                </a>
              </div>
            </div>

            <div className="grid sm:grid-cols-3 grid-cols-2 col-span-2 text-left gap-y-8">
              <div>
                <h3 className="sm:text-base text-sm leading-5 font-semibold text-gray-600 tracking-wider uppercase dark:text-white">
                  Information
                </h3>

                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      to="/"
                      className={"text-gray-600 sm:text-base text-sm hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/' ? " font-bold" : "")}
                    >
                      Home
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/about"
                      className={"text-gray-600 sm:text-base text-sm hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/about' ? " font-bold" : "")}
                    >
                      About
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/data-catalogue"
                      className={"text-gray-600 sm:text-base text-sm hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/data-catalogue' ? " font-bold" : "")}
                    >
                      Data Catalogue
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="">
                <h3 className=" leading-5 font-semibold text-gray-600 tracking-wider uppercase sm:text-base text-sm dark:text-white">
                  Services
                </h3>

                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      to="/privacy-policy"
                      className={"text-gray-600 sm:text-base text-sm leading-6 hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/privacy-policy' ? " font-bold" : "")}
                    >
                      Privacy Policy
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/contact"
                      className={"text-gray-600 sm:text-base text-sm leading-6 hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/contact' ? " font-bold" : "")}
                    >
                      Technical Support
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/terms-and-conditions"
                      className={"text-gray-600 sm:text-base text-sm leading-6 hover:text-gray-900 dark:text-gray-400 hover:dark:text-gray-300" + (window.location.pathname === '/terms-and-conditions' ? " font-bold" : "")}
                    >
                      Terms & Conditions
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="">
                <h3 className="mb-4 leading-5 font-semibold text-gray-600 tracking-wider uppercase sm:text-base text-sm dark:text-white">
                  Contact
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <a
                      className="sm:text-base text-sm leading-6 break-words text-gray-600 hover:text-blue-400 dark:text-gray-400 hover:dark:text-blue-500"
                      href="mailto:info@arcticresearchfoundation.ca"
                    >
                      info@arcticresearchfoundation.ca
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      className="sm:text-base text-sm leading-6 text-gray-600 hover:text-blue-400 mt-8 dark:text-gray-400 hover:dark:text-blue-500"
                      href="https://www.google.com/maps/place/67+Erb+St+W,+Waterloo,+ON+N2L+6C2"
                    >
                      Arctic Research Foundation 67 Erb St W, Waterloo, ON N2L 6C2
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 border-t border-gray-200 pt-8 text-center dark:border-gray-700">
            <p className="text-sm leading-6 text-gray-600 text-center dark:text-gray-400">
              &copy; {new Date().getFullYear()} Arctic Research Foundation. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;